import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-fade';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.01,
		friction: 0.2,
		wrapAround: false,
		cellAlign: 'left',
		contain: true
	} );

	$this.parents( '.carousel-container' ).find( '.carousel-previous' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'previous' );
	} );

	$this.parents( '.carousel-container' ).find( '.carousel-next' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'next' );
	} );

	$this.mouseenter( function() {
		$( this ).flickity().focus();
	} );
} );

$( '.slideshow' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.01,
		friction: 0.2,
		fade: true,
		wrapAround: true,
		autoPlay: 3000
	} );

	$this.parents( '.carousel-container' ).find( '.carousel-previous' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'previous' );
	} );

	$this.parents( '.carousel-container' ).find( '.carousel-next' ).on( 'click', function( clickEvent ) {
		clickEvent.preventDefault();
		$carousel.flickity( 'next' );
	} );
} );
